import { ExternalDiagnosticsPage } from "apps/diagnostics/pages/externalDiagnostics/ExternalDiagnosticsPage";
import { MicrophoneHelp } from "apps/diagnostics/pages/microphoneHelp/MicrophoneHelp";
import { TermsOfUsePage } from "apps/diagnostics/pages/termsOfUse/TermsOfUsePage";
import {
  MICROPHONE_HELP_URL,
  TERMS_AND_CONDITIONS_URL,
} from "apps/diagnostics/externalDiagnostics/externalDiagnosticsConsent/externalDiagnosticsConsent";
import { Constants } from "common/constants";
import { UserAuthGuard } from "components/authguard/UserAuthGuard";
import { RouteObject } from "react-router-dom";
import { ProjectIqApp } from "./ProjectIqApp";
import { ProjectIqAdminPage } from "./pages/ProjectIqAdminPage";
import { AcceptableUsePolicyPage } from "./pages/AcceptableUsePolicyPage/AcceptableUsePolicyPage";

const USER_GROUPS = [
  Constants.PROJECT_IQ_USERS_GROUP_NAME_VALUE,
  Constants.PROJECT_IQ_ADMINS_GROUP_NAME_VALUE,
  Constants.PLATFORM_ADMINS_GROUP_NAME_VALUE,
];

const ADMIN_GROUPS = [
  Constants.PROJECT_IQ_ADMINS_GROUP_NAME_VALUE,
  Constants.PLATFORM_ADMINS_GROUP_NAME_VALUE,
];

export const projectIqRouter: RouteObject[] = [
  {
    path: "/",
    element: <UserAuthGuard component={<ProjectIqApp />} anyOf={USER_GROUPS} />,
  },
  {
    path: "/workspace/:workspaceId",
    element: <UserAuthGuard component={<ProjectIqApp />} anyOf={USER_GROUPS} />,
  },
  {
    path: "/workspace/:workspaceId/:tab",
    element: <UserAuthGuard component={<ProjectIqApp />} anyOf={USER_GROUPS} />,
  },
  {
    path: "/workspace/:workspaceId/nh-diagnostic-iq/:diagnosticId",
    element: (
      <UserAuthGuard
        component={<ProjectIqApp />}
        anyOf={[
          Constants.PROJECT_IQ_USERS_GROUP_NAME_VALUE,
          Constants.PROJECT_IQ_ADMINS_GROUP_NAME_VALUE,
          Constants.PLATFORM_ADMINS_GROUP_NAME_VALUE,
        ]}
      />
    ),
  },
  {
    path: "/workspace/:workspaceId/ai-analytics/:analyticsId",
    element: (
      <UserAuthGuard
        component={<ProjectIqApp />}
        anyOf={[
          Constants.PROJECT_IQ_USERS_GROUP_NAME_VALUE,
          Constants.PROJECT_IQ_ADMINS_GROUP_NAME_VALUE,
          Constants.PLATFORM_ADMINS_GROUP_NAME_VALUE,
        ]}
      />
    ),
  },
  {
    path: "/workspaces",
    element: <UserAuthGuard component={<ProjectIqApp />} anyOf={USER_GROUPS} />,
  },
  {
    path: "/leadership/portfolios",
    element: <UserAuthGuard component={<ProjectIqApp />} anyOf={USER_GROUPS} />,
  },
  {
    path: "/leadership/practices",
    element: <UserAuthGuard component={<ProjectIqApp />} anyOf={USER_GROUPS} />,
  },
  {
    path: "/admin",
    element: (
      <UserAuthGuard component={<ProjectIqAdminPage />} anyOf={ADMIN_GROUPS} />
    ),
  },
  {
    path: "/admin/:section",
    element: (
      <UserAuthGuard component={<ProjectIqAdminPage />} anyOf={ADMIN_GROUPS} />
    ),
  },
  {
    path: "/admin/:section",
    element: (
      <UserAuthGuard component={<ProjectIqAdminPage />} anyOf={ADMIN_GROUPS} />
    ),
  },
  {
    path: "/external-diagnostics/:id/question/next",
    element: <ExternalDiagnosticsPage />,
  },
  {
    path: "/external-diagnostics/question/next",
    element: <ExternalDiagnosticsPage />,
  },
  {
    path: "/diagnostics/terms",
    element: <TermsOfUsePage />,
  },
  {
    path: TERMS_AND_CONDITIONS_URL,
    element: <TermsOfUsePage />,
  },
  {
    path: MICROPHONE_HELP_URL,
    element: <MicrophoneHelp />,
  },
  {
    path: "/acceptable-use-policy",
    element: <AcceptableUsePolicyPage />,
  },
  {
    path: "*",
    element: <UserAuthGuard component={<ProjectIqApp />} anyOf={USER_GROUPS} />,
  },
];
